import React from 'react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_colabella-tutorials/artifacts/wcwuz41r_LOGO.png';

const PrintHeader = ({ title, subtitle }) => {
  return (
    <div className="print-header">
      <div className="print-letterhead">
        <div className="print-logo-row">
          <img src={LOGO_URL} alt="Colabella Group" className="print-logo" />
          <div className="print-company">
            <h1 className="print-company-name">Colabella Group</h1>
            <p className="print-company-subtitle">Gestione Cantieri</p>
          </div>
        </div>
        <div className="print-date-box">
          <span>{new Date().toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}</span>
        </div>
      </div>
      <div className="print-divider" />
      <div className="print-title-row">
        <h2 className="print-doc-title">{title}</h2>
        {subtitle && <p className="print-doc-subtitle">{subtitle}</p>}
      </div>
    </div>
  );
};

export default PrintHeader;
